import { render } from "./TerminationList.vue?vue&type=template&id=cb4d3cda"
import script from "./TerminationList.vue?vue&type=script&lang=js"
export * from "./TerminationList.vue?vue&type=script&lang=js"

import "./TerminationList.vue?vue&type=style&index=0&id=cb4d3cda&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__